<div class="toast-container position-fixed end-0 ps-2 ps-md-4 pe-3 pe-md-5 py-2 overflow-y-auto">
  @for (toast of toasts.toasts; track toast.id) {
    <!--
    https://github.com/ng-bootstrap/ng-bootstrap/issues/4754
    We also need to do the `@if` outside of the toast, since otherwise the template ain't injected.
    -->
    @if (toast.message && toast.message.length > 0) {
      <ngb-toast [class]="getToastClass(toast.type)"
                 [autohide]="autoHide()"
                 [delay]="toast.autoHideAfterMs"
                 (mouseenter)="autoHide.set(false)"
                 (mouseleave)="autoHide.set(true)"
                 (hidden)="toastHidden(toast)">
        <ng-template ngbToastHeader>
          <div class="me-auto">
            <i [rfBsIcon]="getToastIcon(toast.type)"></i>
            <strong class="mx-2">{{ toast.title }}</strong>
          </div>
        </ng-template>
        <span>{{ toast.message }}</span>
      </ngb-toast>
    } @else {
      <ngb-toast [class]="getToastClass(toast.type)"
                 [autohide]="autoHide()"
                 [delay]="toast.autoHideAfterMs"
                 (mouseenter)="autoHide.set(false)"
                 (mouseleave)="autoHide.set(true)"
                 (hidden)="toastHidden(toast)">
        <!--
        The ideal setup for this would be `toast` > `d-flex` > [`toast-body`, `btn-close`].
        But `toast-body` is outside of our control,
        so we cheat by copying the CSS handling of `btn-close` inside `toast-header` (`.toast-no-message`).
         -->
        <div class="d-flex align-items-center toast-no-message">
          <i class="fs-5" [rfBsIcon]="getToastIcon(toast.type)"></i>
          <span class="fw-medium mx-2 me-auto">{{ toast.title }}</span>
          <button type="button" class="btn-close" data-bs-dismiss="toast"
                  aria-label="Close" i18n-aria-label></button>
        </div>
      </ngb-toast>
    }
  }
</div>
